import Backbone from "../../libs/backbone/backbone";
import GenericModel from "./generic.model.ts";

export default GenericModel.extend(
{
    urlRoot : 'rest/api/users',
    id : null,
    name : "",
    lastName : "",
    userName : "",
    email : "",
    privilegeLevel : ""
});

